/* 人脸识别入口 */
export const faceidMixin = {
  data() {
    return {
      isOpenFaceId: 0
    }
  },
  methods: {
    toFaceid(order) {
      window.location.href = `${appPath}/redirect?orderId=${
        order.bookingId
        }&orderNumber=${order.orderNumber}&idCard=${
        order.cardId
        }&redirectType=1&orderName=${order.name}&orgId=${
        order.orgId
        }`
    },
    toQuestionnaire(order) {
      window.location.href = order.redirect_bs_url
    }
  }
}
